<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div style="width: 100%;background-color:white;height: 100vh;display: flex;flex-direction: column;">
      <img src="/static/images/fanxiang/fanxiang-top.jpg" alt="" height="30%" style="top: 0;">

      <div class="text-center" v-html="antiresult" style="height: 40%;display: flex;flex-direction: column;justify-content: center;">
      </div>

      <img src="/static/images/fanxiang/fanxiang-footer.jpg" alt="" height="30%" style="bottom: 0;">
    </div>

    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif"/>
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      antiresult:"",
      codeInfo: null,
      cpmc: null,
      ysfs: null,
      bzq: null,
      gg: null,
      zcfs: null,
      imgsrc: null,
      isShow: false,
      yn: false
    }
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      const code = params.c;
      getAntiResult(code).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          alert("防伪查询失败,请联系管理员");
        } else {
          this.antiresult = data.message
        }
        this.isShow = false
      }).catch(err =>
          alert("查询异常，请联系管理员")
      )

    }
  },
  created: function () {
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FanXiang/Index.vue